import { createRouter, createWebHistory } from "vue-router";

const JeongJayYeong = () => import("@/views/secret/JeongJayYeongView.vue");
const IncompView = () => import("@/views/IncompView.vue");

const HomeView = () => import("../views/HomeView.vue");
const TeamListView = () => import("@/views/TeamListView.vue");
const TeamBrochureView = () => import("@/views/TeamBrochureView.vue");
const RunwayView = () => import("@/views/RunwayView.vue");
const ShowinfoView = () => import("@/views/ShowinfoView.vue");
const BehindView = () => import("@/views/BehindView.vue");

const protophobiaView = () => import("@/views/teams/protophobia/protophobiaView.vue");

const ChoiJunWoo = () => import("@/views/teams/protophobia/members/ChoiJunWooView.vue");
const KwakDoHoon = () => import("@/views/teams/protophobia/members/KwakDoHoonView.vue");
const YunSoHye = () => import("@/views/teams/protophobia/members/YunSoHyeView.vue");
const JeongGyeongMo = () => import("@/views/teams/protophobia/members/JeongGyeongMoView.vue");
const KimMinSeo = () => import("@/views/teams/protophobia/members/KimMinSeoView.vue");
const KimHeeYoung = () => import("@/views/teams/protophobia/members/KimHeeYoungView.vue");
const KimJiIn = () => import("@/views/teams/protophobia/members/KimJiInView.vue");
const LeeEunJi = () => import("@/views/teams/protophobia/members/LeeEunJiView.vue");
const YounDoHee = () => import("@/views/teams/protophobia/members/YounDoHeeView.vue");

const OAKView = () => import("@/views/teams/OAK/OAKView.vue");
const leehansolView = () => import("@/views/teams/OAK/members/leehansolView.vue");
const yunseonmiView = () => import("@/views/teams/OAK/members/yunseonmiView.vue");
const xiesiqiView = () => import("@/views/teams/OAK/members/xiesiqiView.vue");
const zhanghanView = () => import("@/views/teams/OAK/members/zhanghanView.vue");
const huangzinuoView = () => import("@/views/teams/OAK/members/huangzinuoView.vue");
const sonyeajinView = () => import("@/views/teams/OAK/members/sonyeajinView.vue");
const jungyeonsooView = () => import("@/views/teams/OAK/members/jungyeonsooView.vue");
const limdohaView = () => import("@/views/teams/OAK/members/limdohaView.vue");
const panmingyuView = () => import("@/views/teams/OAK/members/panmingyuView.vue");
const songzhaodiView = () => import("@/views/teams/OAK/members/songzhaodiView.vue");
const jixuexinView = () => import("@/views/teams/OAK/members/jixuexinView.vue");

const ANACHRONIAView = () => import("@/views/teams/ANACHRONIA/ANACHRONIAView.vue");
const kimgyubinView = () => import("@/views/teams/ANACHRONIA/members/kimgyubinView.vue");
const kwonnawonView = () => import("@/views/teams/ANACHRONIA/members/kwonnawonView.vue");
const parkhyevinView = () => import("@/views/teams/ANACHRONIA/members/parkhyevinView.vue");
const elinaView = () => import("@/views/teams/ANACHRONIA/members/elinaView.vue");
const jinsonghanyiView = () => import("@/views/teams/ANACHRONIA/members/jinsonghanyiView.vue");
const liuhaihongView = () => import("@/views/teams/ANACHRONIA/members/liuhaihongView.vue");
const ningyiyiView = () => import("@/views/teams/ANACHRONIA/members/ningyiyiView.vue");
const nilinView = () => import("@/views/teams/ANACHRONIA/members/nilinView.vue");
const zhangxueyingView = () => import("@/views/teams/ANACHRONIA/members/zhangxueyingView.vue");

const LoftView = () => import("@/views/teams/Loft/LoftView.vue");
const wangchewonView = () => import("@/views/teams/Loft/members/wangchewonView.vue");
const yoominahView = () => import("@/views/teams/Loft/members/yoominahView.vue");
const kimhajinView = () => import("@/views/teams/Loft/members/kimhajinView.vue");
const parkyebinView = () => import("@/views/teams/Loft/members/parkyebinView.vue");
const sunweiwanView = () => import("@/views/teams/Loft/members/sunweiwanView.vue");
const seeyihyunView = () => import("@/views/teams/Loft/members/seeyihyunView.vue");
const yangjieunView = () => import("@/views/teams/Loft/members/yangjieunView.vue");
const yinlanView = () => import("@/views/teams/Loft/members/yinlanView.vue");
const jangyeajinView = () => import("@/views/teams/Loft/members/jangyeajinView.vue");
const jungsomgyulView = () => import("@/views/teams/Loft/members/jungsomgyulView.vue");

const bugreportView = () => import("@/views/teams/bugreport/bugreportView.vue");
const bugreportLookbookView = () => import("@/views/teams/bugreport/bugreportLookbookView.vue");
const protophobiaLookbookView = () => import("@/views/teams/protophobia/protophobiaLookbookView.vue");
const LoftLookbookView = () => import("@/views/teams/Loft/LoftLookbookView.vue");
const OAKLookbookView = () => import("@/views/teams/OAK/OAKLookbookView.vue");
const DejavuLookbookView = () => import("@/views/teams/Dejavu/DejavuLookbookView.vue");
const ANACHRONIALookbookView = () => import("@/views/teams/ANACHRONIA/ANACHRONIALookbookView.vue");

const ByunSangYoon = () => import("@/views/teams/bugreport/members/ByunSangYoonView.vue");
const KangSoWon = () => import("@/views/teams/bugreport/members/KangSoWonView.vue");
const KimSangEun = () => import("@/views/teams/bugreport/members/KimSangEunView.vue");
const ChoiJeeYoung = () => import("@/views/teams/bugreport/members/ChoiJeeYoungView.vue");
const LeeJuYoung = () => import("@/views/teams/bugreport/members/LeeJuYoungView.vue");
const YooHaYoung = () => import("@/views/teams/bugreport/members/YooHaYoungView.vue");
const LeeJiHyun = () => import("@/views/teams/bugreport/members/LeeJiHyunView.vue");
const YuJiMin = () => import("@/views/teams/bugreport/members/YuJiMinView.vue");
const OhSeungMin = () => import("@/views/teams/bugreport/members/OhSeungMinView.vue");
const HaNaGyeong = () => import("@/views/teams/bugreport/members/HaNaGyeongView.vue");

const DejavuView = () => import("@/views/teams/Dejavu/DejavuView.vue");

const leesujinView = () => import("@/views/teams/Dejavu/members/leesujinView.vue");
const chosoojinView = () => import("@/views/teams/Dejavu/members/chosoojinView.vue");
const leelokyinView = () => import("@/views/teams/Dejavu/members/leelokyinView.vue");
const inouerinView = () => import("@/views/teams/Dejavu/members/inouerinView.vue");
const yimsoyoonView = () => import("@/views/teams/Dejavu/members/yimsoyoonView.vue");
const leechaeonView = () => import("@/views/teams/Dejavu/members/leechaeonView.vue");

const routes = [
  {
    path: "/coming-soon",
    name: "coming-soon",
    component: IncompView,
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/team-list",
    name: "team-list",
    component: TeamListView,
  },
  {
    path: "/team-brochuer",
    name: "team-brochuer",
    component: TeamBrochureView,
  },
  {
    path: "/runway",
    name: "runway",
    component: RunwayView,
  },
  {
    path: "/showinfo",
    name: "showinfo",
    component: ShowinfoView,
  },
  {
    path: "/behind",
    name: "behind",
    component: BehindView,
  },

  {
    path: "/protophobia",
    name: "protophobia",
    component: protophobiaView,
  },

  {
    path: "/protophobia/choi-junwoo",
    name: "choi-junwoo",
    component: ChoiJunWoo,
  },
  {
    path: "/protophobia/kwak-dohoon",
    name: "kwak-dohoon",
    component: KwakDoHoon,
  },
  {
    path: "/protophobia/yun-sohye",
    name: "yun-sohye",
    component: YunSoHye,
  },
  {
    path: "/protophobia/jeong-gyeongmo",
    name: "jeong-gyeongmo",
    component: JeongGyeongMo,
  },
  {
    path: "/protophobia/kim-minseo",
    name: "kim-minseo",
    component: KimMinSeo,
  },
  {
    path: "/protophobia/kim-heeyoung",
    name: "kim-heeyoung",
    component: KimHeeYoung,
  },
  {
    path: "/protophobia/kim-jiin",
    name: "kim-jiin",
    component: KimJiIn,
  },
  {
    path: "/protophobia/lee-eunji",
    name: "lee-eunji",
    component: LeeEunJi,
  },
  {
    path: "/protophobia/youn-dohee",
    name: "youn-dohee",
    component: YounDoHee,
  },
  {
    path: "/protophobia/lookbook",
    name: "protophobia-lookbook",
    component: protophobiaLookbookView,
  },

  {
    path: "/OAK",
    name: "OAK",
    component: OAKView,
  },
  {
    path: "/OAK/lee-hansol",
    name: "lee-hansol",
    component: leehansolView,
  },
  {
    path: "/OAK/yunseonmi",
    name: "yunseonmi",
    component: yunseonmiView,
  },
  {
    path: "/OAK/xiesiqi",
    name: "xiesiqi",
    component: xiesiqiView,
  },
  {
    path: "/OAK/zhanghan",
    name: "zhanghan",
    component: zhanghanView,
  },
  {
    path: "/OAK/huangzinuo",
    name: "huangzinuo",
    component: huangzinuoView,
  },
  {
    path: "/OAK/sonyeajin",
    name: "sonyeajin",
    component: sonyeajinView,
  },
  {
    path: "/OAK/jungyeonsoo",
    name: "jungyeonsoo",
    component: jungyeonsooView,
  },
  {
    path: "/OAK/limdoha",
    name: "limdoha",
    component: limdohaView,
  },
  {
    path: "/OAK/panmingyu",
    name: "panmingyu",
    component: panmingyuView,
  },
  {
    path: "/OAK/songzhaodi",
    name: "songzhaodi",
    component: songzhaodiView,
  },
  {
    path: "/OAK/jixuexin",
    name: "jixuexin",
    component: jixuexinView,
  },
  {
    path: "/OAK/lookbook",
    name: "OAK-lookbook",
    component: OAKLookbookView,
  },

  {
    path: "/ANACHRONIA",
    name: "ANACHRONIA",
    component: ANACHRONIAView,
  },
  {
    path: "/ANACHRONIA/kimgyubin",
    name: "kimgyubin",
    component: kimgyubinView,
  },
  {
    path: "/ANACHRONIA/kwonnawon",
    name: "kwonawon",
    component: kwonnawonView,
  },
  {
    path: "/ANACHRONIA/parkhyevin",
    name: "parkhyevin",
    component: parkhyevinView,
  },
  {
    path: "/ANACHRONIA/elina",
    name: "elina",
    component: elinaView,
  },
  {
    path: "/ANACHRONIA/jinsonghanyi",
    name: "jinsonghanyi",
    component: jinsonghanyiView,
  },
  {
    path: "/ANACHRONIA/liuhaihong",
    name: "liuhaihong",
    component: liuhaihongView,
  },
  {
    path: "/ANACHRONIA/ningyiyi",
    name: "ningyiyi",
    component: ningyiyiView,
  },
  {
    path: "/ANACHRONIA/nilin",
    name: "nilin",
    component: nilinView,
  },
  {
    path: "/ANACHRONIA/zhangxueying",
    name: "zhangxueying",
    component: zhangxueyingView,
  },
  {
    path: "/ANACHRONIA/lookbook",
    name: "ANACHRONIA-lookbook",
    component: ANACHRONIALookbookView,
  },

  {
    path: "/Loft",
    name: "Loft",
    component: LoftView,
  },
  {
    path: "/Loft/wangchewon",
    name: "wangchewon",
    component: wangchewonView,
  },
  {
    path: "/Loft/yoominah",
    name: "yoominah",
    component: yoominahView,
  },
  {
    path: "/Loft/kimhajin",
    name: "kimhajin",
    component: kimhajinView,
  },
  {
    path: "/Loft/parkyebin",
    name: "parkyebin",
    component: parkyebinView,
  },
  {
    path: "/Loft/sunweiwan",
    name: "sunweiwan",
    component: sunweiwanView,
  },
  {
    path: "/Loft/seeyihyun",
    name: "seeyihyun",
    component: seeyihyunView,
  },
  {
    path: "/Loft/yangjieun",
    name: "yangjieun",
    component: yangjieunView,
  },
  {
    path: "/Loft/yinlan",
    name: "yinlan",
    component: yinlanView,
  },
  {
    path: "/Loft/jangyeajin",
    name: "jangyeajin",
    component: jangyeajinView,
  },
  {
    path: "/Loft/jungsomgyul",
    name: "jungsomgyul",
    component: jungsomgyulView,
  },
  {
    path: "/Loft/lookbook",
    name: "Loft-lookbook",
    component: LoftLookbookView,
  },
  {
    path: "/bugreport",
    name: "bugreport",
    component: bugreportView,
  },
  {
    path: "/bugreport/lookbook",
    name: "bugreport-lookbook",
    component: bugreportLookbookView,
  },
  {
    path: "/bugreport/byun-sangyoon",
    name: "ByunSangyoon",
    component: ByunSangYoon,
  },
  {
    path: "/bugreport/choi-jeeyoung",
    name: "ChoiJeeYoung",
    component: ChoiJeeYoung,
  },
  {
    path: "/bugreport/kim-sangeun",
    name: "kim-sangeun",
    component: KimSangEun,
  },
  {
    path: "/bugreport/lee-juyoung",
    name: "lee-huyoung",
    component: LeeJuYoung,
  },
  {
    path: "/bugreport/lee-jihyun",
    name: "lee-jihyun",
    component: LeeJiHyun,
  },
  {
    path: "/bugreport/kang-sowon",
    name: "kang-sowon",
    component: KangSoWon,
  },
  {
    path: "/bugreport/oh-seungmin",
    name: "oh-seungmin",
    component: OhSeungMin,
  },
  {
    path: "/bugreport/yoo-hayoung",
    name: "yoo-hayoung",
    component: YooHaYoung,
  },
  {
    path: "/bugreport/yu-jimin",
    name: "yu-jimin",
    component: YuJiMin,
  },
  {
    path: "/bugreport/ha-nagyeong",
    name: "ha-nagyong",
    component: HaNaGyeong,
  },

  {
    path: "/Dejavu",
    name: "Dejavu",
    component: DejavuView,
  },
  {
    path: "/Dejavu/leesujin",
    name: "leesujin",
    component: leesujinView,
  },
  {
    path: "/Dejavu/chosoojin",
    name: "chosoojin",
    component: chosoojinView,
  },
  {
    path: "/Dejavu/leeokyin",
    name: "leeokyin",
    component: leelokyinView,
  },
  {
    path: "/Dejavu/inoue-rin",
    name: "inoue-rin",
    component: inouerinView,
  },
  {
    path: "/Dejavu/yimsoyoon",
    name: "yimsoyoon",
    component: yimsoyoonView,
  },
  {
    path: "/Dejavu/leechaeon",
    name: "leechaeon",
    component: leechaeonView,
  },
  {
    path: "/Dejavu/lookbook",
    name: "Dejavu-lookbook",
    component: DejavuLookbookView,
  },

  {
    path: "/secret/jeong-jayyeong",
    name: "JeongJayYeong",
    component: JeongJayYeong,
  },
];

// Preserve published routes while giving mistyped URLs a useful recovery page.
routes.push({ path: "/:pathMatch(.*)*", name: "not-found", component: IncompView });

const router = createRouter({
  history: createWebHistory("/2024"),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
